class Export {
  constructor(api) {
    this.api = api;
  }

  getAll(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/exports?paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByType(type, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/exports/?filter[type]=" + type + "&paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByLevel(level, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/exports/mapper/templates?paginate=false&level=" + level)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getCustomReportListOptions(data, onSuccess, onError) {
    let string;
    if(data.all_objects){
      string = `v1/exports/types/${data.workspaceUuid}?layer=${data.layer}&filter=${data.filter}&all_objects=${data.all_objects}`;
    }else{
      string = `v1/exports/types/${data.workspaceUuid}?layer=${data.layer}&filter=${data.filter}`;
    }
    return this.api.http_fibercloud
      .get(string)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getExportMapperTemplatesByPage(page, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/exports/mapper/templates?paginate=false&pageComponent=" + page)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getExportMapperTemplates(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/exports/mapper/templates?paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByTypeAndWorkspace(type, workspaceID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/exports?filter[workspace_id]=" +
          workspaceID +
          "&filter[type]=" +
          type +
          "&paginate=false"
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByUUID(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/exports/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getObjectsToSelectInExport(workspaceUUID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/exports/types/" + workspaceUUID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(data, onSuccess, onError, runType = null) {
    let currentCompanyUUID = localStorage.getItem("company_uuid");
    let headers = {};
    if (runType) {
      headers = {
        'run-type': 'runtime'
      }
    }
    data.company_uuid = currentCompanyUUID;
    return this.api.http_fibercloud
      .post("v1/exports", data, {
        headers: headers
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteByUUID(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/exports/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  cancelByUUID(uuid, onSuccess, onError) {
    let data = { connection: "horizon" };
    return this.api.http_fibercloud
      .post("v1/exports/" + uuid + "/cancel", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteInBulk(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/exports", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Export;



// WEBPACK FOOTER //
// ./src/api/export.js